// Constants
import { ELEMENT_FILTER_CLEAR, ELEMENT_FILTER_SET } from './elementFilterConstants';

export const setElementFilter = (elementFilter) => ({
    type: ELEMENT_FILTER_SET,
    elementFilter,
});

export const clearElementFilter = () => ({
    type: ELEMENT_FILTER_CLEAR,
});
